import {Component, OnInit} from '@angular/core';
import {BehaviorSubject, asyncScheduler} from 'rxjs';
import {observeOn} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {LoadingService} from './loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  imports: [
    AsyncPipe
  ],
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  protected isLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private loadingService: LoadingService) {
  }

  ngOnInit(): void {
    this.loadingService.loading$.pipe(
      observeOn(asyncScheduler)
    ).subscribe((loading) => {
      this.isLoading$.next(loading);
    });
  }
}
